import { addTimestampToFile } from "@thdinc/hpf-shared";
import { ACCEPTED_IMAGE_TYPES, MAX_FILE_SIZE_MB } from "../Common";

export default function ImageUploadFunDropZone(
  acceptedFiles: any,
  size: number = MAX_FILE_SIZE_MB,
  imageTypes: string[] = ACCEPTED_IMAGE_TYPES
) {
  const file = addTimestampToFile(acceptedFiles[0]);
  if (imageTypes.includes(file.type)) {
    if (file.size <= size * 1024 * 1024) {
      return file;
    } else {
      throw new Error(
        `File size exceeds ${size} MB. Please choose a smaller image.`
      );
    }
  } else {
    throw new Error(
      "Please select a valid image file (JPEG, PNG, GIF, BMP, or TIFF)."
    );
  }
}
